import { borderWidth as webBorderWidth } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderWidth";

export const borderWidth = {
  ...webBorderWidth,
  sliderProps: {
    ...webBorderWidth.sliderProps,
    /** @TODO This does not need to be a select because we only have px */
    units: ["px"],
    defaultUnit: "px",
  },
} as const;
